
import { SpotifyArtistProfile } from '@/types';

// Mock data for development
export const mockArtistProfiles: Record<string, SpotifyArtistProfile> = {
  '1': {
    spotifyId: 'spotify-id-1',
    monthlyListeners: 125000,
    popularity: 68,
    topTracks: [
      {
        id: 'track-1',
        name: 'Sunset Boulevard',
        previewUrl: 'https://p.scdn.co/mp3-preview/3eb16018c2a700240e9dfb8817b6f2d041f15eb1',
        imageUrl: 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 78,
        durationMs: 217000,
        artists: ['Alex Turner']
      },
      {
        id: 'track-2',
        name: 'Midnight Dreams',
        previewUrl: 'https://p.scdn.co/mp3-preview/1f8e6abaed907e75c4279d1a0b4dd1750d7529e8',
        imageUrl: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 65,
        durationMs: 198000,
        artists: ['Alex Turner', 'The Dreamers']
      },
      {
        id: 'track-3',
        name: 'Electric Pulse',
        previewUrl: 'https://p.scdn.co/mp3-preview/9e9792373bdc62c2153e5d615c96ebe51c652ec1',
        imageUrl: 'https://images.unsplash.com/photo-1559519847-e07569ea2429?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 72,
        durationMs: 223000,
        artists: ['Alex Turner']
      }
    ],
    audioFeatures: {
      averageTempo: 128,
      averageDanceability: 0.73,
      averageEnergy: 0.82,
      averageValence: 0.65,
      dominantKey: 'C',
      topGenres: ['Hip-Hop', 'Electronic', 'Pop'],
      moodProfile: {
        happy: 0.7,
        energetic: 0.8,
        chill: 0.3,
        melancholic: 0.2
      }
    },
    similarArtists: [
      { id: 'similar-1', name: 'DJ Shadow', genres: ['Electronic', 'Trip-Hop'] },
      { id: 'similar-2', name: 'Flying Lotus', genres: ['Electronic', 'Experimental'] }
    ]
  },
  '2': {
    spotifyId: 'spotify-id-2',
    monthlyListeners: 89000,
    popularity: 72,
    topTracks: [
      {
        id: 'track-4',
        name: 'Golden Hour',
        previewUrl: 'https://p.scdn.co/mp3-preview/2f37da1c6a51ac42e425b3f3e82bda5f5eaa1db4',
        imageUrl: 'https://images.unsplash.com/photo-1515890435781-a6e11036ac98?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 81,
        durationMs: 204000,
        artists: ['Sarah Brooks']
      },
      {
        id: 'track-5',
        name: 'Acoustic Dreams',
        previewUrl: 'https://p.scdn.co/mp3-preview/6da63ed84126c8b7231cd1f8805d175c793c196f',
        imageUrl: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 73,
        durationMs: 187000,
        artists: ['Sarah Brooks', 'Acoustic Ensemble']
      }
    ],
    audioFeatures: {
      averageTempo: 98,
      averageDanceability: 0.58,
      averageEnergy: 0.62,
      averageValence: 0.72,
      dominantKey: 'G',
      topGenres: ['Indie Folk', 'Acoustic', 'Pop'],
      moodProfile: {
        happy: 0.6,
        energetic: 0.4,
        chill: 0.7,
        melancholic: 0.3
      }
    },
    similarArtists: [
      { id: 'similar-3', name: 'Bon Iver', genres: ['Indie Folk', 'Alternative'] }
    ]
  },
  '3': {
    spotifyId: 'spotify-id-3',
    monthlyListeners: 62000,
    popularity: 65,
    topTracks: [
      {
        id: 'track-6',
        name: 'Jazz Fusion',
        previewUrl: 'https://p.scdn.co/mp3-preview/fb891d7307c0a5cfa3a775c9696b93f9be9866c8',
        imageUrl: 'https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 68,
        durationMs: 248000,
        artists: ['Miles Davis Tribute']
      }
    ],
    audioFeatures: {
      averageTempo: 105,
      averageDanceability: 0.45,
      averageEnergy: 0.72,
      averageValence: 0.58,
      dominantKey: 'D',
      topGenres: ['Jazz', 'Rock', 'R&B'],
      moodProfile: {
        happy: 0.5,
        energetic: 0.6,
        chill: 0.5,
        melancholic: 0.4
      }
    }
  },
  '4': {
    spotifyId: 'spotify-id-4',
    monthlyListeners: 117000,
    popularity: 75,
    topTracks: [
      {
        id: 'track-7',
        name: 'Indie Wave',
        previewUrl: 'https://p.scdn.co/mp3-preview/4a4b5bef755a972b0598efa33bcbbdc7b95571be',
        imageUrl: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 79,
        durationMs: 193000,
        artists: ['Indie Collective']
      }
    ],
    audioFeatures: {
      averageTempo: 112,
      averageDanceability: 0.68,
      averageEnergy: 0.75,
      averageValence: 0.62,
      dominantKey: 'A',
      topGenres: ['Alternative Rock', 'Indie', 'Folk Rock'],
      moodProfile: {
        happy: 0.5,
        energetic: 0.7,
        chill: 0.4,
        melancholic: 0.5
      }
    }
  },
  '5': {
    spotifyId: 'spotify-id-5',
    monthlyListeners: 205000,
    popularity: 82,
    topTracks: [
      {
        id: 'track-8',
        name: 'Rhythm Nation',
        previewUrl: 'https://p.scdn.co/mp3-preview/ff298494693e46f56a08cc2e9719244e7f6cd609',
        imageUrl: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
        popularity: 86,
        durationMs: 221000,
        artists: ['DJ Phantom']
      }
    ],
    audioFeatures: {
      averageTempo: 130,
      averageDanceability: 0.85,
      averageEnergy: 0.92,
      averageValence: 0.78,
      dominantKey: 'F',
      topGenres: ['House', 'Techno', 'Electronic'],
      moodProfile: {
        happy: 0.8,
        energetic: 0.9,
        chill: 0.2,
        melancholic: 0.1
      }
    }
  },
  '6': {
    spotifyId: 'spotify-id-6',
    monthlyListeners: 4870000,
    popularity: 89,
    topTracks: [
      {
        id: 'track-burna-1',
        name: 'Omo',
        previewUrl: 'https://www.youtube.com/watch?v=33h-C2WI4UQ',
        youtubeId: '33h-C2WI4UQ',
        imageUrl: 'https://media.gq.com/photos/5e5ebc2cb7235e00084122d3/16:9/w_2990,h_1682,c_limit/burna-boy-gq-style-spring-summer-2020-promo.jpg',
        popularity: 85,
        durationMs: 193000,
        artists: ['Burna Boy']
      },
      {
        id: 'track-burna-2',
        name: 'Gbona',
        previewUrl: 'https://www.youtube.com/watch?v=h7WfPHHXCAY',
        youtubeId: 'h7WfPHHXCAY',
        imageUrl: 'https://media.gq.com/photos/5e5ebc2cb7235e00084122d3/16:9/w_2990,h_1682,c_limit/burna-boy-gq-style-spring-summer-2020-promo.jpg',
        popularity: 88,
        durationMs: 204000,
        artists: ['Burna Boy']
      }
    ],
    audioFeatures: {
      averageTempo: 108,
      averageDanceability: 0.78,
      averageEnergy: 0.75,
      averageValence: 0.68,
      dominantKey: 'E',
      topGenres: ['Afrobeats', 'Afro-fusion', 'Nigerian Pop'],
      moodProfile: {
        happy: 0.7,
        energetic: 0.8,
        chill: 0.5,
        melancholic: 0.2
      }
    },
    similarArtists: [
      { id: 'similar-6-1', name: 'Wizkid', genres: ['Afrobeats', 'Nigerian Pop'] },
      { id: 'similar-6-2', name: 'Davido', genres: ['Afrobeats', 'Nigerian Pop'] }
    ]
  }
};
